import type {RefObject} from 'react';
import {useCallback, useRef, useState} from 'react';

export interface UsePopoverAnchorResult<T extends HTMLElement = HTMLDivElement> {
  anchorRef: RefObject<T | null>;
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export function usePopoverAnchor<T extends HTMLElement = HTMLDivElement>(): UsePopoverAnchorResult<T> {
  const anchorRef = useRef<T | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const open = useCallback((): void => {
    setIsOpen(true);
  }, []);

  const close = useCallback((): void => {
    setIsOpen(false);
  }, []);

  return {anchorRef, isOpen, open, close};
}
